<template>
  <div class="">
    <nav class="navbar navbar-lg navbar-expand-lg navbar-transparant navbar-dark navbar-absolute w-100 justify-content-between">
      <div class="text-left scales-logo-white">
        <img src="../../../static/img/landing/SCALES-LOGO-WHITE.png" class="img-fluid" />
      </div>
      <div class="dropdown">
        <button class="btn btn-outline-white dropdown-toggle mr-2" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{$t('navbar.language')}}
        </button>
        <div class="dropdown-menu">
          <button class="dropdown-item" @click="changeLanguage('en')">
            {{$t('languageChoice.English')}}
          </button>
          <!--<button class="dropdown-item" @click="changeLanguage('zh')">
            {{$t('languageChoice.Chinese')}}
          </button>
          <button class="dropdown-item" @click="changeLanguage('jp')">
            {{$t('languageChoice.Japanese')}}
          </button>-->
        </div>
      </div>
    </nav>
    <div class=" pt-8 pb-3 position-relative">
      <div class="">
        <img src="../../../static/img/landing/TOP_Backgrand_1200-800.png" class="img-fluid img-cover" />
      </div>
      <div class="intro-content mt-0 mt-md-5 text-white">
        <div class="container">
          <div class="row">
            <div class="col-md-6 align-self-center">
              <h1 class="display-4 mb-3">{{$t('Landing.text1')}}<br />{{$t('Landing.text2')}}</h1>
              <h2 class="mb-1">{{$t('Landing.text4')}}</h2>
              <h5 class="lead mb-4" v-html="$t('Landing.text3')"></h5>
            </div>
            <div class="col-md-5 ml-auto">
              <div class="card">
                <div class="card-body text-dark">
                  <form label-width="0px" class="demo-ruleForm needs-validation-sign-up" novalidate>
                    <div class="form-group">
                      <label for="email">{{$t('LandingForm.Email')}}</label>
                      <input type="email" class="form-control" id="email" v-model="email" required :placeholder="$t('LandingForm.Emailplaceholder')">
                      <div class="invalid-feedback">
                        {{$t('LandingForm.emailTips')}}
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="password">{{$t('LandingForm.Password')}}</label>
                      <input type="password" class="form-control" id="password" v-model="password" required :placeholder="$t('LandingForm.Passwordplaceholder')">
                      <div class="invalid-feedback">
                        {{$t('LandingForm.PasswordTips')}}
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="checkPassword">{{$t('LandingForm.Repeatpassword')}}</label>
                      <input type="password" class="form-control" id="checkPassword" v-model="checkPassword" required :placeholder="$t('LandingForm.Repeatpsdplaceholder')">
                      <div class="invalid-feedback">
                        {{$t('LandingForm.RepeatpsdTips')}}
                      </div>
                      <div class="invalid-feedback password-not-match" style="display:none">
                        {{$t('LandingForm.PsdAndPassword')}}
                      </div>
                    </div>
                    <button type="submit" class="btn btn-success btn-block btn-lg mb-2 mt-4" @click="signUp">{{$t('LandingForm.Signup')}}</button>
                    <div class="text-center">
                      {{$t('LandingForm.SigninLeft')}}
                      <router-link to="/user/login">{{$t('LandingForm.Signin')}}</router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ml-3 mt-3 text-left" style="width:80px">
          <a :href="$t('LandingForm.TwitterLink')" target="_blank" style="border-bottom-style: none;">
            <img src="../../../static/img/landing/Twitter_WHITE.png" class="img-fluid" />
          </a>
        </div>
      </div>
    </div>
    <main class="main" role="main">
      <div class="bg-white pb-6">
        <div class="container">
          <div class="landing-video-container row">
            <video id="landing-video" src="../../../static/img/promo00.mp4" autobuffer autoplay muted controls loop></video>
          </div>
          <div class="row pt-3">
            <div class="col-md-4 offset-md-1 pl-3 pl-md-4">
              <h2 v-html="$t('LandingCentertext1.textTop1')"></h2>
            </div>
            <div class="col-md-6 ">
              <p class="lead text-dark">
                {{$t('LandingCentertext1.textTop2')}}
              </p>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-md-4">
              <div class="media">
                <div class="icon mr-3">
                  <i class="far fa-id-badge"></i>
                </div>
                <div class="media-body">
                  <h3 class="h4">{{$t('LandingCentertext1.Sustainable')}}</h3>
                  <p class="text-dark text-left">
                    {{$t('LandingCentertext1.WhereverText')}}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="media">
                <div class="icon mr-3">
                  <i class="far fa-hand-scissors"></i>
                </div>
                <div class="media-body">
                  <h3 class="h4">{{$t('LandingCentertext1.Secure')}}</h3>
                  <p class="text-dark text-left">
                    {{$t('LandingCentertext1.WheneverText')}}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="media">
                <div class="icon mr-3">
                  <i class="far fa-comments"></i>
                </div>
                <div class="media-body">
                  <h3 class="h4">{{$t('LandingCentertext1.Convenience')}}</h3>
                  <p class="text-dark text-left">
                    {{$t('LandingCentertext1.WhoeverText')}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-light py-6">
        <div class="container">
          <div class="row">
            <div class="col-md-4 offset-md-1 pl-3 pl-md-4">
              <h2 v-html="$t('LandingCentertext2.textTop1')"></h2>
            </div>
            <div class="col-md-6">
              <p class="lead text-dark">
                {{$t('LandingCentertext2.textTop2')}}
              </p>
            </div>
          </div>
          <div class="row mt-5 col-12 col-md-12 no-gutters px-3 px-md-0">
            <div class="col-4 col-md-4 px-0 px-md-3 center-vertical">
              <img src="../../../static/img/landing/card1-1.png" class="img-fluid" />
            </div>
            <div class="col-3 col-md-3 px-0 px-md-3 center-vertical">
              <img src="../../../static/img/landing/card1-2.png" class="img-fluid" />
            </div>
            <div class="col-3 col-md-3 px-0 px-md-3 center-vertical">
              <img src="../../../static/img/landing/card1-3.png" class="img-fluid" />
            </div>
            <div class="col-2 col-md-2 px-1 px-md-3 center-vertical">
              <img src="../../../static/img/landing/card1-4.png" class="img-fluid" />
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white pt-6 ">
        <div class="container">
          <div class="row">
            <div class="col-md-4 offset-md-1 pl-3 pl-md-4">
              <h2 v-html="$t('LandingCentertext3.textTop1')"></h2>
            </div>
            <div class="col-md-6">
              <p class="lead text-dark">
                {{$t('LandingCentertext3.textTop2')}}
              </p>
            </div>
          </div>
          <div class="col-md-12 p-0 center-vertical" style="justify-content: center;">
            <button class="btn btn-success btn-block btn-lg mb-2 mt-4 col-md-4" @click="goTop">{{$t('Landing.tryToService')}}</button>
          </div>
          <div class="mt-5 card3">
            <div style="width:1200px;">
              <div class="card2-img" style="width: 300px;">
                <img src="../../../static/img/landing/card2-1.png" class="img-fluid" />
              </div>
              <div class="card2-img" style="width: 150px;top:50px;margin-left:-60px;">
                <img src="../../../static/img/landing/card2-2.svg" class="img-fluid" />
              </div>
              <div class="card2-img" style="width: 500px;margin-left:15px;">
                <img src="../../../static/img/landing/card2-3.png" class="img-fluid" />
              </div>
              <div class="card2-img" style="width: 100px;margin-left:-555px;top:50px;">
                <img src="../../../static/img/landing/card2-10.svg" class="img-fluid" />
              </div>
              <div class="card2-img" style="width: 180px;margin-left:0px;top:10px;">
                <img src="../../../static/img/landing/card2-4.png" class="img-fluid" />
              </div>
              <div class="card2-img" style="width: 100px;margin-left:0px;top:10px;">
                <img src="../../../static/img/landing/card2-10.svg" class="img-fluid" />
              </div>
              <div class="card2-img" style="width: 150px;margin-left:0px;top:-20px;">
                <img src="../../../static/img/landing/card2-5.svg" class="img-fluid" />
              </div>
              <div class="card2-img" style="width: 100px;margin-left:0px;top:-30px;">
                <img src="../../../static/img/landing/card2-10.svg" class="img-fluid" />
              </div>
              <div class="card2-img" style="width: 150px;margin-left:0px;top:-30px;">
                <img src="../../../static/img/landing/card2-8.png" class="img-fluid" />
              </div>
              <div class="card2-img" style="width: 100px;margin-left:-80px;top:-60px;">
                <img src="../../../static/img/landing/card2-9.png" class="img-fluid" />
              </div>
              <div class="card2-img" style="width: 150px;margin-left:-700px;top:160px;">
                <img src="../../../static/img/landing/card6-3.png" class="img-fluid" />
              </div>
              <div class="card2-img" style="width: 120px;margin-left:120px;top:210px;">
                <img src="../../../static/img/landing/card2-7.png" class="img-fluid" />
              </div>
              <div class="card2-img" style="width: 100px;transform: rotate(180deg);margin-left:-235px;top:150px;">
                <img src="../../../static/img/landing/card2-11.svg" class="img-fluid" />
              </div>
              <div class="card2-img" style="font-size: 28px;font-weight: bold;margin-left:-265px;top:-70px;">{{$t('LandingCentertext3.text1')}}</div>
              <div class="card2-img" style="font-size: 28px;font-weight: bold;margin-left:-30px;top:70px;">{{$t('LandingCentertext3.text2')}}</div>
              <div class="card2-img" style="font-size: 46px;font-weight: bold;margin-left:20px;top:90px;">{{$t('LandingCentertext3.text3')}}</div>
              <div class="card2-img" style="font-size: 13px;font-weight: bold;margin-left:-100px;top:-90px;" v-html="$t('LandingCentertext3.text4')"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-light py-6">
        <div class="container">
          <div class="row">
            <div class="col-md-6 pl-3 pl-md-4">
              <img src="../../../static/img/landing/card3-1.png" class="img-fluid" />
            </div>
            <div class="col-md-6 center-vertical">
              <div class="lead text-dark">
                <h2>{{$t('LandingCentertext4.textTop1')}}</h2>
                <p>{{$t('LandingCentertext4.textTop2')}}</p>
                <div class="col-md-12 p-0 center-vertical">
                  <button class="btn btn-success btn-block btn-lg mb-2 mt-4 col-md-8" @click="goTop">{{$t('Landing.tryToService')}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="py-6 text-white" style="background-color:rgb(255, 128, 128)">
        <div class="container">
          <div class="row">
            <div class="col-md-4 offset-md-1 pl-3 pl-md-4">
              <h2>{{$t('LandingBottom1.Title')}}<br /> {{$t('LandingBottom1.Title2')}}</h2>
            </div>
            <div class="col-md-6">
              <p class="lead text-white">
                {{$t('LandingBottom1.TitleTips')}}
              </p>
            </div>
            <div class="col-md-12 mx-auto">
              <div class="row align-items-center my-md-4 text-center col-12 no-gutters p-0">
                <div class="col-3 col-md-3 px-0 px-md-3 center-vertical">
                  <img src="../../../static/img/landing/card4-1.png" class="img-fluid" />
                </div>
                <div class="col-3 col-md-3 px-1 px-md-3 center-vertical">
                  <img src="../../../static/img/landing/card4-2.png" class="img-fluid" />
                </div>
                <div class="col-3 col-md-3 px-1 px-md-3 center-vertical">
                  <img src="../../../static/img/landing/card4-3.png" class="img-fluid" />
                </div>
                <div class="col-3 col-md-3 px-1 px-md-3 pr-md-0 center-vertical">
                  <img src="../../../static/img/landing/card4-4.png" class="img-fluid" />
                </div>
                <div class="col-3 col-md-3 px-1 px-md-3 center-vertical">
                  <img src="../../../static/img/landing/card4-5.png" class="img-fluid" />
                </div>
                <div class="col-3 col-md-3 px-1 px-md-3 center-vertical">
                  <img src="../../../static/img/landing/card4-6.png" class="img-fluid" />
                </div>
                <div class="col-3 col-md-3 px-1 px-md-3 center-vertical">
                  <img src="../../../static/img/landing/card4-7.png" class="img-fluid" />
                </div>
                <div class="col-3 col-md-3 px-1 px-md-3 center-vertical" style="justify-content: center;">
                  <img src="../../../static/img/landing/card4-8.png" class="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-light py-6">
        <div class="container">
          <div class="row">
            <div class="col-md-6 center-vertical">
              <div class="lead text-dark">
                <h2>{{$t('LandingCentertext5.textTop1')}}</h2>
                <p v-html="$t('LandingCentertext5.textTop2')"></p>
                <div class="col-md-12 p-0 center-vertical">
                  <button class="btn btn-success btn-block btn-lg mb-2 mt-4 col-md-8" @click="goTop">{{$t('Landing.tryToService')}}</button>
                </div>
              </div>
            </div>
            <div class="row col-md-6 pt-3 pl-3 pl-md-4 pr-0">
              <div class="col-4 col-md-4 pr-0 center-vertical">
                <img src="../../../static/img/landing/card5-1.png" class="img-fluid" />
              </div>
              <div class="col-4 col-md-4 pr-0 center-vertical">
                <img src="../../../static/img/landing/card2-10.svg" class="img-fluid" />
              </div>
              <div class="col-4 col-md-4 center-vertical pr-0">
                <img src="../../../static/img/landing/card2-4.png" class="img-fluid" />
              </div>
              <div class="col-12 pt-3">
                <div class="col-6 col-md-6 offset-3 offset-md-3 center-vertical pr-0">
                  <img src="../../../static/img/landing/card5-3.png" class="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white pt-6">
        <div class="col-12 col-md-9 mx-auto">
          <div class="">
            <div class="col-md-12 text-center">
              <div class="lead text-dark">
                <h2>{{$t('LandingCentertext6.textTop1')}}</h2>
                <h3>{{$t('LandingCentertext6.textTop2')}}</h3>
              </div>
            </div>
            <div class="pt-6 mt-6 mb-5 card6-1">
              <div style="width:1300px;">
                <div class="card6-img" style="width: 130px;margin-left:15px;">
                  <img src="../../../static/img/landing/card6-16.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;top:-30px;margin-left:80px;z-index:3;">
                  <img src="../../../static/img/landing/card2-4.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:45px;">
                  <img src="../../../static/img/landing/card6-5.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 155px;margin-left:-320px;top:120px;">
                  <img src="../../../static/img/landing/card6-9.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:120px;">
                  <img src="../../../static/img/landing/card6-3.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:40px;">
                  <img src="../../../static/img/landing/card6-5.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:-50px;">
                  <img src="../../../static/img/landing/card2-7.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:40px;">
                  <img src="../../../static/img/landing/card6-5.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:40px;">
                  <img src="../../../static/img/landing/card6-7.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:-230px;">
                  <img src="../../../static/img/landing/card6-6.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="font-size:26px;font-weight: bold;margin-left:-1094px;top:26px;color:#ffffff" v-html="$t('LandingCentertext6.text1')"></div>
                <div class="card6-img" style="font-size: 16px;font-weight: bold;margin-left:118px;top:40px;">{{$t('LandingCentertext6.text2')}}</div>
                <div class="card6-img" style="font-size: 16px;font-weight: bold;margin-left:168px;top:80px;">{{$t('LandingCentertext6.text3')}}</div>
                <div class="card6-img text-center" style="font-size: 16px;font-weight: bold;margin-left:138px;top:135px;" v-html="$t('LandingCentertext6.text4')"></div>
                <div class="card6-img" style="font-size: 16px;font-weight: bold;margin-left:160px;top:120px;" v-html="$t('LandingCentertext6.text5')"></div>
                <div class="card6-img" style="font-size: 23px;font-weight: bold;margin-left:-932px;top:-130px;" v-html="$t('LandingCentertext6.step1')"></div>
                <div class="card6-img" style="font-size: 23px;font-weight: bold;margin-left:152px;top:-130px;" v-html="$t('LandingCentertext6.step2')"></div>
                <div class="card6-img" style="font-size: 23px;font-weight: bold;margin-left:136px;top:-130px;" v-html="$t('LandingCentertext6.step3')"></div>
                <div class="card6-img" style="font-size: 23px;font-weight: bold;margin-left:162px;top:-130px;" v-html="$t('LandingCentertext6.step4')"></div>
              </div>
            </div>
            <div class="row col-md-12">
            </div>
            <div class="col-md-12 text-center">
              <div class="lead text-dark">
                <h2>{{$t('LandingCentertext6.textTop3')}}</h2>
                <h3>{{$t('LandingCentertext6.textTop4')}}</h3>
              </div>
            </div>
            <div class="mt-3 pt-6 mb-3 card6-2">
              <div style="width:1300px;">
                <div class="card6-img" style="width: 130px;margin-left:15px;">
                  <img src="../../../static/img/landing/card6-8.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;top:-30px;margin-left:80px;z-index:3;">
                  <img src="../../../static/img/landing/card2-4.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:45px;">
                  <img src="../../../static/img/landing/card6-5.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 155px;margin-left:-320px;top:120px;">
                  <img src="../../../static/img/landing/card6-9.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:110px;">
                  <img src="../../../static/img/landing/card6-3.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:40px;">
                  <img src="../../../static/img/landing/card6-5.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 260px;margin-left:-66px;">
                  <img src="../../../static/img/landing/card6-10.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:10px;top:0px;">
                  <img src="../../../static/img/landing/card6-5.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:20px;top:0px;">
                  <img src="../../../static/img/landing/card6-14.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:-215px;top:0px;">
                  <img src="../../../static/img/landing/card2-8.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 200px;margin-left:-635px;top:-66px;">
                  <img src="../../../static/img/landing/card6-11.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 155px;margin-left:5px;top:120px;">
                  <img src="../../../static/img/landing/card6-9.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 230px;margin-left:-30px;top:120px;">
                  <img src="../../../static/img/landing/card6-13.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="width: 130px;margin-left:-26px;top:202px;">
                  <img src="../../../static/img/landing/card2-7.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="font-size: 16px;font-weight: bold;margin-left:-1028px;top:40px;">{{$t('LandingCentertext6.text2')}}</div>
                <div class="card6-img" style="font-size: 16px;font-weight: bold;margin-left:156px;top:80px;">{{$t('LandingCentertext6.text3')}}</div>
                <div class="card6-img" style="font-size: 16px;font-weight: bold;margin-left:206px;top:50px;">{{$t('LandingCentertext6.text2')}}</div>
                <div class="card6-img" style="font-size: 16px;font-weight: bold;margin-left:202px;top:-120px;">{{$t('LandingCentertext6.text5')}}</div>
                <div class="card6-img" style="width: 280px;margin-left:-506px;top:0px;">
                  <img src="../../../static/img/landing/card6-17.png" class="img-fluid" />
                </div>
                <div class="card6-img" style="font-size: 26px;font-weight: bold;margin-left:-236px;top:1px; color:#fff">{{$t('LandingCentertext6.text6')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <copyright></copyright>
    <div class="modal fade" id="registSuccess" tabindex="-1" role="dialog" aria-labelledby="registSuccess" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="authenticatorModalLabel">
              {{$t('registSuccess.Title')}}
            </h4>
          </div>
          <div class="modal-body text-left pt-5 pb-5">
            {{$t('registSuccess.TitleTips')}}
          </div>
          <div class="modal-footer pt-5 pb-3">
            <div class=" col-12 text-center">
              <button class="btn btn-lg btn-primary" data-dismiss="modal">{{$t('registSuccess.OK')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="../../../static/css/dashboard.css" />

<script type="text/javascript">
import copyright from './copyright'
import { NmsClient, RestCfg, Env } from '../../scripts/AllExport'
import crypto from 'crypto'
import Cookies from 'js-cookie'
let registerReqType = 'user-regist'
export default {
  components: { copyright },
  data: function() {
    return {
      email: '',
      password: '',
      checkPassword: ''
    }
  },
  mounted() {
    this.$i18n.locale = 'en'
    Cookies.set('language', 'en', { path: '/', expires: Env.COOKIES_TTL })
  },
  methods: {
    goTop() {
      $(document.documentElement).animate({
        scrollTop: 0
      }, 300)
    },
    signUp() {
      let form = $('.needs-validation-sign-up')[0]

      form.onsubmit = event => {
        event.preventDefault()
        if (this.checkpass(form) && form.checkValidity()) {
          let password = this.createHash(this.checkPassword)
          NmsClient.send(
            RestCfg.POST,
            {
              reqType: registerReqType,
              email: this.email,
              password: password
            },
            this.registResult,
            null
          )
        }
        form.classList.add('was-validated')
      }
    },
    registResult(response) {
      $('#registSuccess').modal('show')
    },
    createHash(password) {
      // パスワードハッシュ化
      let md5 = crypto.createHash('md5')
      let md5Sum = md5.update(password)
      return md5Sum.digest('Base64')
    },
    checkpass(from) {
      let jqCheckPassword = $('#checkPassword')
      $('#checkPassword,#password')
        .off('input propertychange')
        .on('input propertychange', () => {
          if (this.password !== this.checkPassword) {
            jqCheckPassword
              .removeClass('password-valid')
              .addClass('password-invalid')
            if (this.checkPassword === '') {
              jqCheckPassword
                .parent()
                .find('.password-not-match')
                .css({ display: 'none' })
              return
            }
            jqCheckPassword
              .parent()
              .find('.password-not-match')
              .css({ display: 'block' })
          } else {
            jqCheckPassword
              .parent()
              .find('.password-not-match')
              .css({ display: 'none' })
            if (this.checkPassword === null || this.checkPassword === '') return
            jqCheckPassword
              .removeClass('password-invalid')
              .addClass('password-valid')
          }
        })
      if (!from.checkValidity()) {
        return
      }
      if (this.password !== this.checkPassword) {
        jqCheckPassword
          .removeClass('password-valid')
          .addClass('password-invalid')
        jqCheckPassword
          .parent()
          .find('.password-not-match')
          .css({ display: 'block' })
        return false
      } else {
        jqCheckPassword
          .removeClass('password-invalid')
          .addClass('password-valid')
        return true
      }
    },
    changeLanguage(language) {
      let setLanguage = language
      Cookies.set('language', setLanguage, {
        path: '/',
        expires: Env.COOKIES_TTL
      })
      this.$i18n.locale = setLanguage
    }
  }
}
</script>
<style scoped>
.landing-video-container video{
  width:100%;
  padding:0px 15px
}
@media (max-width: 578px){
  .landing-video-container video{
    padding:0px 0px
  }
}
@media (max-width: 991.98px){
  .scales-logo-white {
    width:60px;
    margin-left: 1.5rem;
  }
  .dropdown{
    position: relative;
    margin:1.5rem 1.5rem
  }
  .navbar{
    padding:0px 0px
  }
}
@media (min-width: 991.98px){
  .scales-logo-white {
    width:135px;
  }
  .dropdown{
    position: absolute !important;
    z-index: 999 !important;
    top: 0 !important;
    right: 0 !important;
    margin: 1.5rem 1.5rem;
  }
}

.form-group {
  margin-bottom: 1rem;
  height: 83px;
}
.navbar {
  font-weight: normal;
}
.navbar-brand button {
  background-color: white;
}
.navbar-brand {
  font-size: 1.25rem;
}
.center-vertical {
  display: flex;
  align-items: center;
}
.card6-img{
  position: relative;
  display: inline-block;
}
.card2-img{
  position: relative;
  display: inline-block;
}
@media (max-width: 1200px) {
  .card3{
    overflow-x: auto;
    position: relative;
    white-space: nowrap;
    height:450px;
  }

}
@media (min-width: 1200px) {
  .card3{
    overflow-x: auto;
    position: relative;
    white-space: nowrap;
    height:450px;
    width:1200px;
  }

}
@media (max-width: 1500px) {
  .card6-1{
    overflow-x: auto;
    position: relative;
    white-space: nowrap;
    height:380px;
    width:auto;
  }
 .card6-2{
    overflow-x: auto;
    position: relative;
    white-space: nowrap;
    height:560px;
    width:auto;
  }
}
@media (min-width: 1500px) {
  .card6-1{
    overflow-x: auto;
    position: relative;
    white-space: nowrap;
    height:380px;
    width:1300px;
  }
  .card6-2{
    overflow-x: auto;
    position: relative;
    white-space: nowrap;
    height:560px;
    width:1300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/landing.vue